/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Findings_TitleInputs */



/**
* | output |
* | --- |
* | "Who is behind a change" |
*
* @param {Landing_Findings_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_findings_title = /** @type {((inputs?: Landing_Findings_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Findings_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кто стоит за изменением")
	return /** @type {LocalizedString} */ ("Who is behind a change")
});